
const getDefaultState = () => {
    return {
        id:"",
        name:"",
        lastName:"",
        phone:"",
        email:"",
        emailConfirmation:"",
        fieldErrors: {
            name: "",
            lastName: "",
            phone: "",
            email: "",
            emailConfirmation: ""
        }
    }
}

const state = getDefaultState();

//Actions
const actions = {
    setID({commit}, payload){
        commit('SET_ID', payload)
    },
    setName({commit}, payload){
        commit('SET_NAME', payload)
    },
    setLastName({commit}, payload){
        commit('SET_LAST_NAME', payload)
    },
    setPhone({commit}, payload){
        commit('SET_PHONE', payload)
    },
    setEmail({commit}, payload){
        commit('SET_EMAIL', payload)
    },
    setEmailConfirmation({commit}, payload){
        commit('SET_EMAIL_CONFIRMATION', payload)
    },
    setFieldError({commit}, { field, message }){
        commit('SET_FIELD_ERROR', { field, message })
    },
    clearFieldError({commit}, field){
        commit('CLEAR_FIELD_ERROR', field)
    },
    setValidationErrors({commit}, errors){
        commit('SET_VALIDATION_ERRORS', errors)
    },
    clearAllFieldErrors({commit}){
        commit('CLEAR_ALL_FIELD_ERRORS')
    },
    validatePersonData(){
        if(state.name == ""){throw "El nombre es obligatorio"}
        if(state.lastName == ""){throw "El apellido es obligatorio"}
        if(state.phone == ""){throw "El celular es obligatorio"}
        if(state.email == ""){throw "El email es obligatorio"}
        if(state.emailConfirmation == ""){throw "La confirmación del email es obligatorio"}
    },
}

//Getters
const getters = {
    fieldError: (state) => (field) => state.fieldErrors[field] || ""
}

//Mutations
const mutations = {
    SET_ID(state, payload){
        state.id=payload;
    },
    SET_NAME(state, payload){
        state.name=payload;
        state.fieldErrors.name = "";
    },
    SET_LAST_NAME(state, payload){
        state.lastName=payload;
        state.fieldErrors.lastName = "";
    },
    SET_PHONE(state, payload){
        state.phone=payload;
        state.fieldErrors.phone = "";
    },
    SET_EMAIL(state, payload){
        state.email=payload;
        state.fieldErrors.email = "";
    },
    SET_EMAIL_CONFIRMATION(state, payload){
        state.emailConfirmation=payload;
        state.fieldErrors.emailConfirmation = "";
    },
    SET_FIELD_ERROR(state, { field, message }){
        if (state.fieldErrors[field] !== undefined) {
            state.fieldErrors[field] = message;
        }
    },
    CLEAR_FIELD_ERROR(state, field){
        if (state.fieldErrors[field] !== undefined) {
            state.fieldErrors[field] = "";
        }
    },
    SET_VALIDATION_ERRORS(state, errors){
        state.fieldErrors = { ...state.fieldErrors, ...errors };
    },
    CLEAR_ALL_FIELD_ERRORS(state){
        state.fieldErrors = {
            name: "",
            lastName: "",
            phone: "",
            email: "",
            emailConfirmation: ""
        };
    }
}


const cotizacion = {
    namespaced: true,
    actions,
    getters,
    mutations,
    state
}


export default cotizacion